import React from 'react';
import {Typography, Button, alpha} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Link, useParams } from 'react-router-dom';
import { MontosPES } from './Participaciones/Estatales/MontosPE';
import { CalculosPE } from './Participaciones/Estatales/CalculosPE';
import { MenuPublico } from './MenuPublico';

const orangeBase = '#ff8400';
const grayBase = '#f2f2f2';

const theme = createTheme({
  palette: {
    primary: {
      main: orangeBase,
      light: alpha(orangeBase, 0.5),
      dark: alpha(orangeBase, 0.7),
      contrastText: '#ffffff',
    },
    secondary: {
      main: grayBase,
      light: alpha(grayBase, 0.5),
      dark: alpha(grayBase, 0.7),
      contrastText: '#ff8400',
    },
  },
});


const HomePagePE: React.FC = () => {
  const { tipo } = useParams()
  return (
    <div className="main-content-wrapper">
      <ThemeProvider theme={theme}>
        <MenuPublico selectedLink={2} />
        <Button color="primary" size="large" variant="contained" className="category-btn">
          <Typography variant="h6">PARTICIPACIONES ESTATALES</Typography>
        </Button>
        <div className="nav-categories">
          <Button color={tipo === 'montos' ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/participaciones-estatales/montos" className="category-btn">
            <center>Montos</center>
          </Button>
          <Button color={tipo === 'calculos' ? "primary" : "secondary"} size="large" variant="contained" component={Link} to="/participaciones-estatales/calculos" className="category-btn">
            <center>Cálculos</center>
          </Button>
        </div>
        {
          tipo === 'montos' &&
          <MontosPES />
        }
        {
          tipo === 'calculos' &&
          <CalculosPE />
        }

      </ThemeProvider>

    </div>
  );
};

export default HomePagePE;
